import React, { useEffect, useState } from 'react';
import { useFormatage } from '../hooks/useAgroshopHooks';
import { produitsService } from '../services/api';

export default function StockPanel({ produits_en_stock = [] }) {
  const { formatPrix } = useFormatage();
  const [localProducts, setLocalProducts] = useState(produits_en_stock);
  const [editingId, setEditingId] = useState(null);
  const [prixModif, setPrixModif] = useState('');
  const [actionError, setActionError] = useState('');

  useEffect(() => {
    setLocalProducts(produits_en_stock);
  }, [produits_en_stock]);

  const stockMax = Math.max(1, ...(localProducts.map((p) => p.stock_disponible || 0)));

  const handleEdit = (produit) => {
    setEditingId(produit.id);
    setPrixModif(produit.prix_unitaire?.toString() || '');
    setActionError('');
  };

  const handleCancel = () => {
    setEditingId(null);
    setPrixModif('');
    setActionError('');
  };

  const handleSave = async (produit) => {
    const prix = Number(prixModif);
    if (Number.isNaN(prix) || prix < 0) {
      setActionError('Veuillez saisir un prix valide.');
      return;
    }
    try {
      const updated = await produitsService.update(produit.id, { prix_unitaire: prix });
      setLocalProducts((prev) => prev.map((item) => (item.id === produit.id ? { ...item, prix_unitaire: updated.prix_unitaire } : item)));
      handleCancel();
    } catch (err) {
      setActionError(err.message || 'Impossible de mettre à jour le produit.');
    }
  };

  const handleDelete = async (produit) => {
    if (!window.confirm(`Supprimer le produit ${produit.nom} ? Cette action est irréversible.`)) {
      return;
    }
    try {
      await produitsService.delete(produit.id);
      setLocalProducts((prev) => prev.filter((item) => item.id !== produit.id));
    } catch (err) {
      setActionError(err.message || 'Impossible de supprimer le produit.');
    }
  };

  return (
    <section className="ag-dashboard-panel">
      <div className="ag-dashboard-panel-header">
        <div>
          <h3>Niveaux de stock</h3>
          <p className="ag-muted">{produits_en_stock.length} produits disponibles</p>
        </div>
      </div>

      {actionError && <div className="ag-alert ag-alert-error">{actionError}</div>}
      <ul className="ag-stock-list">
        {localProducts.slice(0, 8).map((produit) => {
          const ratio = Math.round(((produit.stock_disponible || 0) / stockMax) * 100);
          const isEditing = editingId === produit.id;
          return (
            <li key={produit.id} className="ag-stock-item">
              <div className="ag-stock-item-meta" style={{ width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <strong>{produit.nom}</strong>
                  <span>{produit.stock_disponible} en stock</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', alignItems: 'center', marginTop: '8px' }}>
                  {isEditing ? (
                    <>
                      <input
                        type="number"
                        min="0"
                        value={prixModif}
                        onChange={(event) => setPrixModif(event.target.value)}
                        style={{ width: '100px' }}
                      />
                      <button type="button" className="ag-btn" onClick={() => handleSave(produit)}>Enregistrer</button>
                      <button type="button" className="ag-btn-secondary" onClick={handleCancel}>Annuler</button>
                    </>
                  ) : (
                    <>
                      <span>{formatPrix(produit.prix_unitaire)}</span>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button type="button" className="ag-btn" onClick={() => handleEdit(produit)}>Modifier</button>
                        <button type="button" className="ag-btn-secondary" onClick={() => handleDelete(produit)}>Supprimer</button>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="ag-stock-progress-bar">
                <div className="ag-stock-progress" style={{ width: `${ratio}%` }} />
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
